import React from "react"
import axios from "axios"
import { SellForm as FormComponent } from "@organic-return/foundation-react/src/components/Forms/SellForm"
import { useSiteContext } from "../common/SiteContext"
import { getRecaptchaToken } from "../../lib/utils"
import { graphql } from "gatsby"

const SellForm = (props: any) => {
    const siteContext = useSiteContext()

    return (
        <FormComponent
            formId={props.formId}
            title={props.title}
            classNames="max-w-screen-lg mx-auto"
            clickHandler={async formInput => {
                const recaptchaToken = await getRecaptchaToken("sell_with_us");
                
                await axios({
                    url: process.env.LEAD_CREATE_SELL_WITH_US_API_ENDPOINT,
                    method: "POST",
                    data: {
                        recaptchaToken,
                        formValues: {
                            FirstName: formInput.firstName,
                            LastName: formInput.lastName,
                            Email: formInput.email,
                            Phone: formInput.phone,
                            AdditionalInformation: formInput.textarea,
                            Location: formInput.location,
                            Beds: formInput.beds,
                            Baths: formInput.baths,
                            SquareFeet: formInput.sqft,
                            Condition: formInput.condition,
                            PropertyType: formInput.propertytype,
                            PropertySubType: formInput.propertysubtype,
                        },
                    },
                })
            }}
            {...siteContext.globalSellFormProps}
        />
    )
}

export default SellForm

export const query = graphql`
fragment DrupalSellFormContent on DrupalSellForm {    
    id
    blocktype
    formId
    title
}
`